<template>
  <section class="simulation-contact">
    <div class="c-inner">
      <div class="contact-catch">
        <p class="contact-catch__text">
          シミュレーションの結果をメールにて送信いたします。<br />メールアドレスをご入力の上、ご送信ください。
        </p>
      </div>
      <div class="contact-block">
        <h2 class="contact-block__heading">お客様情報の入力</h2>
        <div class="contact-inquiry">
          <h3 class="contact-inquiry__title">メールアドレス</h3>
          <div class="contact-set">
            <input
              type="email"
              id="email"
              class="contact-text"
              size="25"
              v-model="inputEmail"
              data-conv-half-alphanumeric="true"
            />
            <p v-show="validationMailError" class="contact-caution">
              メールアドレスが正しくありません
            </p>
          </div>
          <div class="contact-set">
            <p class="contact-set__title">メールアドレス(確認のため再入力)</p>
            <input
              type="email"
              id="email2"
              class="contact-text"
              size="25"
              v-model="inputEmailAgain"
              data-conv-half-alphanumeric="true"
            />
            <p v-show="validationAgainError" class="contact-caution">
              メールアドレスが一致しません
            </p>
          </div>
        </div>
        <div class="contact-privacy">
          <h2 class="contact-privacy__heading">
            個人情報保護の取り扱いについて
          </h2>
          <div class="contact-privacy__wrapper">
            <p class="contact-privacy__text">
              <a href="https://www.khi.co.jp/privacy_policy/" target="_blank"
                >個人情報の取扱いに関する方針</a
              >
            </p>
            <p class="contact-privacy__note">
              「個人情報の取扱いに関する方針」をご確認いただき、同意いただける場合は以下のボタンよりご送信ください。
            </p>
          </div>
        </div>
        <div class="contact-back">
          <button
            type="button"
            class="contact-back__btn"
            @click="move('result')"
          >
            &lt; 戻る
          </button>
        </div>
        <div class="contact-submit">
          <button
            type="button"
            class="contact-submit__btn"
            @click="clickSend()"
          >
            送信する
          </button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import {
  GENDER_LABELS,
  PERSON_LABELS,
  LIFESTAGE_LABELS,
  INS_PRODUCTS_LABELS,
} from "@/const.js";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "TheContact",
  components: {},
  props: {},
  data() {
    return {
      inputEmailAgain: "",
      validationMailError: false,
      validationAgainError: false,
    };
  },
  computed: {
    ...mapGetters([
      "getPerson",
      "getPrice",
      "getOptionPrice",
      "getValueFromLabel",
      "isInsuredPerson",
      "getEmail",
    ]),
    genders() {
      return GENDER_LABELS;
    },
    persons() {
      return PERSON_LABELS;
    },
    lifestages() {
      return LIFESTAGE_LABELS;
    },
    insProducts() {
      return INS_PRODUCTS_LABELS;
    },
    productObj() {
      return (product) => {
        return this.insProducts.find((pro) => pro.ID === product);
      };
    },
    inputEmail: {
      get() {
        return this.getEmail;
      },
      set(value) {
        this.$store.commit("updateEmail", { value });
      },
    },
    mailFormatCheck() {
      return (str) => {
        return str.match(/.+@.+\..+/);
      };
    },
  },
  methods: {
    ...mapMutations(["changePage"]),
    move(next) {
      this.changePage({ next });
    },
    clickSend() {
      if (this.mailFormatCheck(this.inputEmail)) {
        this.validationMailError = false;
        if (this.inputEmail === this.inputEmailAgain) {
          this.$emit("send-submit");
          // console.log("OK");
        } else {
          this.validationAgainError = true;
        }
      } else {
        this.validationMailError = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.simulation {
  &-confirmation {
    background-color: $color-bg-main;
  }
}
.contact {
  &-catch {
    @include pc {
      padding: 60px 0;
    }
    @include sp {
      padding: 40px 0;
    }
  }
  &-block {
    &__heading {
      font-weight: 800;
      color: $color-orange;
      border-bottom: 1px solid $color-orange;
      @include pc {
        @include font-size(22px);
        margin-bottom: 30px;
      }
      @include sp {
        @include font-size(18px);
        margin-bottom: 20px;
      }
    }
  }
  &-inquiry {
    margin: 40px 0;
    color: $color-text-black;
    @include pc {
      @include font-size(18px);
    }
    @include sp {
      @include font-size(16px);
    }
    &__title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 40px;
      margin-bottom: 20px;
      padding: 0 20px;
      font-weight: 800;
      @include font-size(16px);
      background-color: $color-bg-contact;
      color: $color-text-black;
    }
  }
  &-set {
    margin-bottom: 20px;
    &__title {
      font-weight: 800;
      line-height: 1;
      margin-bottom: 5px;
    }
  }
  &-text {
    @include pc {
      padding: 5px 10px;
      @include font-size(18px);
    }
    @include sp {
      padding: 5px;
      @include font-size(16px);
    }
  }
  &-privacy {
    margin: 40px 0;
    &__heading {
      font-weight: 800;
      @include pc {
        @include font-size(18px);
      }
      @include pc {
        @include font-size(16px);
      }
    }
    &__text {
      a {
        color: $color-blue;
        text-decoration: underline;
      }
    }
    &__note {
      margin: 20px 0;
      @include font-size(12px);
    }
  }
  &-back {
    &__btn {
      text-decoration: underline;
    }
  }
  &-submit {
    margin-top: 40px;
    &__btn {
      background-color: $color-orange;
      color: #fff;
      width: 100%;
      height: 80px;
      font-weight: 800;
      @include font-size(20px);
      border: none;
      &:hover {
        cursor: pointer;
        opacity: 0.7;
      }
    }
  }
  &-caution {
    color: $color-red;
  }
}
</style>